import { render } from "./dashboardView.vue?vue&type=template&id=66551590"
import script from "./dashboardView.vue?vue&type=script&lang=js"
export * from "./dashboardView.vue?vue&type=script&lang=js"

import "./dashboardView.vue?vue&type=style&index=0&id=66551590&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__